import React from 'react';
import ChecklistPage from '../components/checklist/ChecklistPage';
import { OPERATIONS_CHECKLIST_PAGE } from '../config/checklistPageConfig';

const ReadyForAIPage = () => <ChecklistPage pageConfig={OPERATIONS_CHECKLIST_PAGE} />;

export default ReadyForAIPage;
